import { Skeleton, Stack } from "@mui/material";

// Rows can't be labelled until the definitions response lands, which carries the names.
export const ProductTypeListSectionLoading = () => {
  return (
    <Stack gap={4}>
      <Skeleton variant="text" height={40} />

      <Stack gap={1}>
        {Array.from({ length: 3 }).map((_, index) => (
          <Skeleton key={index} variant="rounded" height={44} />
        ))}
      </Stack>
    </Stack>
  );
};
